import React from "react";
import { stylex } from "./stylex";
import { AutoSizer } from "./auto_sizer";

interface ScrollableProps {
  children?: React.ReactNode;
  direction?: "vertical" | "horizontal";
  testID?: string;
}

export function Scrollable(props: ScrollableProps) {
  const { children, direction = "vertical", testID } = props;

  return (
    <AutoSizer
      disableHeight={direction === "horizontal"}
      disableWidth={direction === "vertical"}
    >
      {({ width, height }) => (
        <div
          data-component="Scrollable"
          data-testid={testID}
          style={{
            ...styles(direction),
            width: direction === "horizontal" ? width : "initial",
            height: direction === "vertical" ? height : "initial",
          }}
        >
          {children}
        </div>
      )}
    </AutoSizer>
  );
}

const styles = stylex.create({
  vertical: {
    overflowY: "scroll",
  },
  horizontal: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
  },
});
